// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1rv4l","col":"Table_col__2YLcp","fulfillmentStatus":"Table_fulfillmentStatus__3kWaK","emailCol":"Table_emailCol__3lktx"};